import { useLocation, useNavigate } from "react-router-dom";

import gsap from "gsap";

export const useNavigation = () => {
  const navigation = useNavigate();

  const location = useLocation();

  const navigate = (navigatePath: any) => {
    const loader = document.querySelector(".loader") as HTMLElement;

    location.pathname.includes("/detail") && navigatePath.includes("/detail")
      ? gsap
          .timeline({
            onComplete: () => {
              navigation(navigatePath);
            },
          })
          .to(".cards .detail-card", {
            opacity: 0,
            stagger: 0.05,
          })
          .to([".detail-next", ".video", ".detail-caption"], {
            opacity: 0,
            stagger: 0.05,
            delay: -0.2,
          })
          .reversed()
      : gsap
          .timeline()
          .to(
            loader,
            {
              opacity: 1,
              visibility: "visible",
              duration: 0.4,
              onComplete: () => {
                navigation(navigatePath);
              },
            },
            0
          )
          .to(loader, {
            opacity: 0,
            duration: 0.4,
          })
          .to(loader, {
            visibility: "hidden",
            duration: 0,
          });
  };

  return navigate;
};
